export default "__VITE_ASSET__Bbs9whix__"